<template>
    <div class="hello text-center">
        <!-- <img src="../assets/images/404.png" alt="" width="367" style="margin-bottom: -15%;"> -->
        <div class="error-bg"></div>
        <div v-if="code" class="error-code">{{code}}</div>
        <h1 class="error-msg">{{msg}}</h1>
        <h2><a class="return-btn" @click.prevent="$root.goKKPage">返回施小慧</a></h2>
    </div>
</template>

<script type="text/babel">
    import qs from 'qs'

    export default {
        name: 'error',
        data () {
            return {
                msg: '',
                code: '',
                from: ''
            }
        },
        methods: {

        },
        created() {
            let _query = this.$route?this.$route.query:qs.parse(window.location.search.substr(1))
            ;['msg','code','from'].forEach(k=>{
                this[k] = _query[k]
            })
           
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a {
        color: #42b983;
    }

    .hello {
        padding: 100px 0;
    }
    .error-bg{
        background: url(../assets/images/404.png) 0 0/367px 317px no-repeat;
        height: 280px;
        width: 367px;
        margin: auto;
    }
    .error-code{
        color: #c1d8c7;
        font-family: sans-serif;
        font-weight: 900;
        font-size: 48px;
    }
    .error-msg{
        color: #abb7ad;
        font-size: 16px;
        font-weight: normal;
    }
    .return-btn{
        font-weight: normal;
        font-size: 16px;
        padding: 10px 20px;
        color: #7dad85;
        border-radius: 5px;
        border: 1px solid #7dad85;
    }
</style>



// WEBPACK FOOTER //
// Error.vue?22941e48